//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

/**
 * Error strings in the format:
 * "Error: VM Exception while processing transaction:
 * reverted with reason string 'Pool is not open to deposits'"
 */
const reasonStringRegex = /'(.*?)'/gm
export const extractReasonString = (fullError: string): string => {
  const match = reasonStringRegex.exec(fullError)
  if (match === null) return ''
  return match[0].replaceAll("'", '')
}

export const getAlertActivityDescription = (activity: any): string => {
  if (activity === 'none') return ''
  else if (activity === 'LOAN_CREATE') return 'Error creating loan: '
  return ''
}

/*
  Error reason strings to be overriden with desired value 
*/
export const MESSAGE_OVERRIDES: any = {
  'Pool is not open to deposits': 'Investment Window is Closed',
}
